import React from 'react';
import ParkingQueueForm from './ParkingQueueForm';
import {useParams} from "react-router-dom"

export default function AddParkingQueueItem() {
  let { locationId } = useParams();
  return <ParkingQueueForm locationId={Number(locationId)} />;
}
